// extracted by mini-css-extract-plugin
module.exports = {"page_location":"styles_page_location__IX1w_","region":"styles_region__YgGAc"};